import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { SummerlinPage } from './pages/SummerlinPage';
import { SouthernHighlandsPage } from './pages/SouthernHighlandsPage';
import { HendersonPage } from './pages/HendersonPage';
import { MacDonaldHighlandsPage } from './pages/MacDonaldHighlandsPage';
import { SpringValleyPage } from './pages/SpringValleyPage';
import { SouthwestPage } from './pages/SouthwestPage';
import { NorthLasVegasPage } from './pages/NorthLasVegasPage';
import { GreenValleyPage } from './pages/GreenValleyPage';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-charcoal selection:bg-gold selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
        <Route path="/summerlin" element={<SummerlinPage data-id="element-6" />} data-id="element-5" />
        <Route path="/southern-highlands" element={<SouthernHighlandsPage data-id="element-8" />} data-id="element-7" />
        <Route path="/henderson" element={<HendersonPage data-id="element-10" />} data-id="element-9" />
        <Route path="/macdonald-highlands" element={<MacDonaldHighlandsPage data-id="element-12" />} data-id="element-11" />
        <Route path="/spring-valley" element={<SpringValleyPage data-id="element-14" />} data-id="element-13" />
        <Route path="/southwest" element={<SouthwestPage data-id="element-16" />} data-id="element-15" />
        <Route path="/north-las-vegas" element={<NorthLasVegasPage data-id="element-18" />} data-id="element-17" />
        <Route path="/green-valley" element={<GreenValleyPage data-id="element-20" />} data-id="element-19" />
      </Routes>
      <Footer data-id="element-21" />
    </div>;
}